import { checkRoofRows, siteGeometryErrors } from "./siteGeometry";
import { descriptorRows } from "./projectScene";
import { moduleQuads, overlapCount } from "./moduleLayout";

// Scene edits belong to an orientation, regardless of which form is open.
export const sceneEditFields = ["site_geometry", "module_offsets", "module_array", "array_offset_east_m", "array_offset_north_m"];

export function sceneFormWithEdits(form, layout) {
  if (!layout) return form;
  return { ...form, ...Object.fromEntries(sceneEditFields.filter((key) => key in layout).map((key) => [key, layout[key]])) };
}

export function scenePlaneWithEdits(plane, layout) {
  if (!layout) return plane;
  const siteGeometry = layout.site_geometry || plane.siteGeometry;
  return { ...plane, spacing: { ...plane.spacing, ...layout },
    siteGeometry: siteGeometry?.roof && plane.siteGeometry?.roof ? { ...siteGeometry,
      roof: { ...siteGeometry.roof, pitchDeg: plane.siteGeometry.roof.pitchDeg, azimuthDeg: plane.siteGeometry.roof.azimuthDeg },
    } : siteGeometry, previewOnly: true };
}

export function invalidSceneEdits(planes, edits) {
  return (planes || []).filter((plane) => {
    if (!edits[plane.id]) return false;
    if (siteGeometryErrors(plane.siteGeometry).length) return true;
    const rows = descriptorRows(plane);
    if (Number(plane.totalModules) > 0 && !rows.length) return true;
    const quads = rows.some((r) => r.slot) ? rows : moduleQuads(rows, plane.tiers);
    const status = checkRoofRows(plane.siteGeometry, quads);
    return status.outside || status.intersecting || status.belowRoof || overlapCount(quads);
  }).map((p) => p.label);
}
